import { isCapacitorPlatform } from "@utils/specific/capacitor";
import { Capacitor } from "@capacitor/core";

export function getDsn() {
	if (isCapacitorPlatform && !isCapacitorPlatform()) {
		return WEBPACK_SENTRY_BASE_DSN;
	}

	if (Capacitor.getPlatform() === "ios") {
		return WEBPACK_SENTRY_IOS_DSN;
	}

	return WEBPACK_SENTRY_ANDROID_DSN;
}
